import React, {Component} from 'react';
import ExpandButton from '../ExpandButton';
import "../../../css/tableStyles.css";
import "./atablestyles.css";

const NewRow = (props) => {
    return (<div className="flexRow rowWrap">
        <div className="flexCell fourCols">{props.item.Location}, {(props.item.Building !== 1) ? "Building " + props.item.Building : ""} Floor {props.item.Floor}</div>
        <div className="flexCell fourCols">{props.item.Material_Description} - asbestos {props.item.Asbestos.toLowerCase()}</div>
        <div className="flexCell fourCols">{props.item.Amount_of_damage}</div>
        <div className="flexCell fourCols">{props.item.Priority}</div>

    </div>)
}

class AsbestosTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clicked: false
        }

        this.renderCutoff = this.renderCutoff.bind(this);
        this.renderAllRows = this.renderAllRows.bind(this);
        this.handleClicked = this.handleClicked.bind(this);

    }

    handleClicked() {
        this.setState({
            clicked: !this.state.clicked
        })
    }


    renderCutoff() {
        return (this.props.reports.slice(0, 5).map((c,i) => (<NewRow item={c} key={i}/>)))
    }


    renderAllRows() {
        return (this.props.reports.map((c,i) => (<NewRow item={c} key={i}/>)))
    }

    render() {
        const reports = this.props.reports;
        let cutoff = this.props.reports.length > 5 ? true : false;

        if(reports.length > 0) {
            return (
                <div className="table-wrap table-asbestos">
                    <div className="flexTable">
                        <div className="flexTableHead">
                            <div className="flexCell fourCols">Location</div>
                            <div className="flexCell fourCols">Description</div>
                            <div className="flexCell fourCols">Amount of damage</div>
                            <div className="flexCell fourCols">Priority</div>
                        </div>

                        {
                            (() => {
                                if (cutoff && !this.state.clicked) {
                                    return this.renderCutoff()
                                } else if (cutoff && this.state.clicked) {
                                    return this.renderAllRows()
                                } else {
                                    return this.renderAllRows()
                                }
                            })()
                        }
                        {
                            (() => {
                                if(reports.length > 5) {
                                    return (<ExpandButton length={this.props.reports.length} clicked={this.state.clicked} onStateChange={this.handleClicked}/>)
                                }
                            })()
                        }
                    </div>

                </div>
            )
        }
          else {
            return (
                <div className="noreports">
                No reports
            </div>
        )
        }

    }
}

export default AsbestosTable;



// WEBPACK FOOTER //
// ./src/components/tables/Asbestos/AsbestosTable.js